import { render, staticRenderFns } from "./taosf1.vue?vue&type=template&id=aba92bc0&scoped=true&"
import script from "./taosf1.vue?vue&type=script&lang=js&"
export * from "./taosf1.vue?vue&type=script&lang=js&"
import style0 from "./taosf1.vue?vue&type=style&index=0&id=aba92bc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba92bc0",
  null
  
)

export default component.exports